/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ImprintRouteImport } from './routes/imprint'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BrandsIndexRouteImport } from './routes/brands.index'
import { Route as BrandsNewRouteImport } from './routes/brands.new'
import { Route as BrandsBrandIdRouteImport } from './routes/brands.$brandId'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const ImprintRoute = ImprintRouteImport.update({
  id: '/imprint',
  path: '/imprint',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const BrandsIndexRoute = BrandsIndexRouteImport.update({
  id: '/brands/',
  path: '/brands/',
  getParentRoute: () => rootRouteImport,
} as any)
const BrandsNewRoute = BrandsNewRouteImport.update({
  id: '/brands/new',
  path: '/brands/new',
  getParentRoute: () => rootRouteImport,
} as any)
const BrandsBrandIdRoute = BrandsBrandIdRouteImport.update({
  id: '/brands/$brandId',
  path: '/brands/$brandId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/imprint': typeof ImprintRoute
  '/privacy': typeof PrivacyRoute
  '/settings': typeof SettingsRoute
  '/terms': typeof TermsRoute
  '/brands/$brandId': typeof BrandsBrandIdRoute
  '/brands/new': typeof BrandsNewRoute
  '/brands/': typeof BrandsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/imprint': typeof ImprintRoute
  '/privacy': typeof PrivacyRoute
  '/settings': typeof SettingsRoute
  '/terms': typeof TermsRoute
  '/brands/$brandId': typeof BrandsBrandIdRoute
  '/brands/new': typeof BrandsNewRoute
  '/brands': typeof BrandsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/imprint': typeof ImprintRoute
  '/privacy': typeof PrivacyRoute
  '/settings': typeof SettingsRoute
  '/terms': typeof TermsRoute
  '/brands/$brandId': typeof BrandsBrandIdRoute
  '/brands/new': typeof BrandsNewRoute
  '/brands/': typeof BrandsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/imprint'
    | '/privacy'
    | '/settings'
    | '/terms'
    | '/brands/$brandId'
    | '/brands/new'
    | '/brands/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/imprint'
    | '/privacy'
    | '/settings'
    | '/terms'
    | '/brands/$brandId'
    | '/brands/new'
    | '/brands'
  id:
    | '__root__'
    | '/'
    | '/imprint'
    | '/privacy'
    | '/settings'
    | '/terms'
    | '/brands/$brandId'
    | '/brands/new'
    | '/brands/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ImprintRoute: typeof ImprintRoute
  PrivacyRoute: typeof PrivacyRoute
  SettingsRoute: typeof SettingsRoute
  TermsRoute: typeof TermsRoute
  BrandsBrandIdRoute: typeof BrandsBrandIdRoute
  BrandsNewRoute: typeof BrandsNewRoute
  BrandsIndexRoute: typeof BrandsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/imprint': {
      id: '/imprint'
      path: '/imprint'
      fullPath: '/imprint'
      preLoaderRoute: typeof ImprintRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/brands/': {
      id: '/brands/'
      path: '/brands'
      fullPath: '/brands/'
      preLoaderRoute: typeof BrandsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/brands/new': {
      id: '/brands/new'
      path: '/brands/new'
      fullPath: '/brands/new'
      preLoaderRoute: typeof BrandsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/brands/$brandId': {
      id: '/brands/$brandId'
      path: '/brands/$brandId'
      fullPath: '/brands/$brandId'
      preLoaderRoute: typeof BrandsBrandIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ImprintRoute: ImprintRoute,
  PrivacyRoute: PrivacyRoute,
  SettingsRoute: SettingsRoute,
  TermsRoute: TermsRoute,
  BrandsBrandIdRoute: BrandsBrandIdRoute,
  BrandsNewRoute: BrandsNewRoute,
  BrandsIndexRoute: BrandsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
